export default __webpack_public_path__ + "static/media/404_image.2132e8bb.svg";